import { render, staticRenderFns } from "./errorIcon.vue?vue&type=template&id=521cd226&"
import script from "./errorIcon.vue?vue&type=script&lang=js&"
export * from "./errorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports